module.exports = __webpack_public_path__ + "img/pocketid.aaaf0c48.jpg";